var app = angular.module('leonardo');

var AccountService = function(BaseRestService, $q, RestangularProvider) {
  var service = new BaseRestService('accounts', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('accounts', false, function(account) {
      account.addRestangularMethod('share', 'post', 'share-account-alias');
      account.addRestangularMethod('dismiss', 'post', 'dismiss-managed-by');
      account.addRestangularMethod('dismissPartial', 'post', 'partial-dismiss-managed-by');
      account.addRestangularMethod('accountsAvailables', 'get', 'accounts-availables');
      return account;
    });
  });

  service.STATUS_PENDING = '0';
  service.STATUS_ACTIVE = '1';
  service.STATUS_ON_BOARDING = '2';
  service.STATUS_REJECTED = '3';


  service.CURRENCY_CODE_US = 'us';
  service.CURRENCY_CODE_UK = 'uk';
  service.CURRENCY_CODE_CA = 'ca';

  service.CURRENCY_CODE_OPTIONS = [
    {code: service.CURRENCY_CODE_US, name: 'USD'},
    {code: service.CURRENCY_CODE_UK, name: 'GBP'},
    {code: service.CURRENCY_CODE_CA, name: 'CAD'},
  ];

  service.STATUS_OPTIONS = [
    {id: service.STATUS_PENDING, name: 'Pending'},
    {id: service.STATUS_ACTIVE, name: 'Active'},
    {id: service.STATUS_ON_BOARDING, name: 'On Boarding'},
    {id: service.STATUS_REJECTED, name: 'Rejected'}
  ];

  service.getBillingReports = function(params) {
    var defer = $q.defer();
    RestangularProvider.all('accounts').customGET('report/billing', params).then(function(data){
      defer.resolve(data);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.getStatuses = function() {
    return [
      service.STATUS_PENDING,
      service.STATUS_ACTIVE,
      service.STATUS_ON_BOARDING,
      service.STATUS_REJECTED
    ];
  };

  service.activate = function(account, sector, name) {
    var data = {
      sector: sector,
      name: name
    };
    return account.customPOST(data, 'activate');
  };

  service.reject = function(account) {
    return account.customPOST({}, 'reject');
  };

  service.onboardingFinished = function(account) {
    return account.customPOST({}, 'onboarding-finished');
  };

  service.updateLanguages = function(account, data) {
    return account.customPOST(data, 'update-languages');
  }

  return service;
};

app.factory('AccountService', ['BaseRestService', '$q', 'Restangular', AccountService]);
